import { Injectable, inject } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { RestClientList } from '@elderbyte/ngx-starter'
import { environment } from '../../../environments/environment'
import { Company } from './company'

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends RestClientList<Company, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger('CompanyService')

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)
    super(environment.apiPath + '/companies', http)
  }
}
